import dayjs from 'dayjs'
import type { IDropdownItem } from 'shared/ui'

export const monthItems: IDropdownItem[] = Array(12)
  .fill(0)
  .map((_, index) => ({
    id: dayjs().month(index).format('MM'),
    label: dayjs().month(index).format('MMMM'),
  }))
